import { BuilderJSON } from 'store';
import styles from './index.module.css';

export const ButtonThemeTertiary = ({
  type = `button`,
  onClick = () => {},
  children,
  iconOnly = false
}) => {
  const { pages } = BuilderJSON((state) => state);
  const primary = pages?.global?.style?.button?.primary;

  return (
    <>
      <button
        type={type}
        onClick={onClick}
        className={styles.button}
        style={{
          backgroundColor: `transparent`,
          color: primary?.backgroundColor,
          borderRadius: `0px`,
          lineHeight: iconOnly ? 0 : `normal`
        }}
      >
        {children}
      </button>
    </>
  );
};
